import client from './client';

export const register = (data) => client.post('/auth/register', data);
export const login = (data) => client.post('/auth/login', data);
export const registrationStatus = () => client.get('/auth/registration-status');
export const me = () => client.get('/auth/me');
export const updateMe = (data) => client.patch('/auth/me', data);
export const updateMyPassword = (data) => client.patch('/auth/me/password', data);
export const forgotPassword = (data) => client.post('/auth/forgot-password', data);
export const resetPassword = (data) => client.post('/auth/reset-password', data);
export const logout = () => client.post('/auth/logout');
export const refresh = (refreshToken) => client.post('/auth/refresh', { refreshToken });
